import React, { useState } from "react";
import { Form, Input } from "antd";
// import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import toast from "react-hot-toast";
import { useNavigate } from 'react-router-dom';
import { ResetApi } from "../../api/request/users";
import { removeCookies } from "../../services/Cookies.jsx";
import { useSelector } from 'react-redux';
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import Lock from "../../assets/auth/Lock.jsx";

function ResetPassword() {

  const navigate = useNavigate();
  const { broker } = useSelector(state => state.broker);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ newpassword: "", confirmpassword: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { newpassword, confirmpassword } = formData;
    if (newpassword !== confirmpassword) {
      toast.error("New password and Confirm password do not match");
      return;
    }
    
    if (!newpassword || !confirmpassword) {
      toast.error("New password or Confirm password can not be empty.");
      return;
    }
    try {
      setIsLoading(true);
      let params = {
        newPassword: (formData?.newpassword),
        confirmPassword:(formData?.confirmpassword)
      }

      const { data } = await ResetApi(params);
      if (data?.success) {
        toast.success(data?.message);
        localStorage.clear('email');
        removeCookies('passwordToken');
        navigate("/");
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* <div className="bgImage w-full"> */}
      {/* <div className="flex items-center justify-center h-full "> */}
     <div className='flex items-center justify-center min-h-screen bg-[#f9f9f9] auth-bg'>
        {/* <div className="flex auth_card flex-col bg-[#FFFFFF] rounded-3xl justify-center items-center px-10 py-10 gap-6 xl:w-1/3 lg:w-1/2 md:w-3/4 w-full "> */}
         <div className='w-full max-w-md bg-white p-10 rounded-2xl shadow-xl'>
          <div className="flex justify-center mb-6">
            {/* <img src={broker?.logoFilePath} className='h-[100px] w-[140px] object-contain' alt='logo' /> */}
            <img src='/assets/logo/logo.png' alt='logo' className='h-20 w-48 object-contain ' />
          </div>
          <div className="text-center">
            <p className="text-[#2F2B3D] text-2xl font-semibold auth-heading">
              Reset Your Password
            </p>
            <p className="text-[silver] text-sm font-medium auth-com mt-2 ">
              Please enter your new password to continue.
            </p>
          </div>

          <div className="w-full">
            <form autoComplete="off" onSubmit={handleSubmit}>
              <div className="w-full text-sm font-normal py-1 mt-3">
                <div div className="relative">
                  <img
                    src="../assets/images/lock.svg"
                    alt=""
                    className="absolute top-[15%] left-5"
                  />
                  <Form.Item name="newpassword">
                    <Input.Password
                      placeholder="Enter your new password"
                      className="border rounded-lg w-full ps-4 py-2 transperant-input"
                      prefix={
                        <Lock/>
                      }
                      name="newpassword"
                      onChange={handleChange}
                      value={formData.newpassword}
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="w-full text-sm font-normal py-1 mt-3">
                <div div className="relative">
                  <img
                    src="../assets/images/lock.svg"
                    alt=""
                    className="absolute top-[15%] left-5"
                  />
                  <Form.Item name="confirmpassword">
                    <Input.Password
                      placeholder="Confirm your password"
                      className="border rounded-lg w-full ps-4 py-2 transperant-input"
                      prefix={
                        <Lock/>
                      }
                      name="confirmpassword"
                      onChange={handleChange}
                      value={formData.confirmpassword}
                    />
                  </Form.Item>
                </div>
              </div>

              <div className="mt-5">
                <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Reset Password' isLoading={isLoading} loadingLable='Reseting Password...' />
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}
export default ResetPassword;
